module.exports = __webpack_public_path__ + "img/defaultUserProfilePhoto.040f0902.svg";